// "Do with root" (D-038 layout): the page-level entry to root, the AI assistant (D-057). root needs
// activation (AI-001, no AI binding on Workers Free), so it opens root's panel (Coming soon) and runs
// nothing. look="root" (the default; owner 2026-10-24, on every page that had the button): instead of
// the button, the 3D root strolls in the same spot and opens the same panel when clicked. The plain
// button (look="button") keeps the 2D AI bot (D-043) on a white chip so its gradient reads on the
// brand fill. look="sit": root sits in a narrow spot instead of strolling (Promotions).
import { useState } from "react";
import { t } from "@ady/i18n";
import { Icon } from "@ady/ui";
import { StrollingRoot } from "../ai-mascot";
import { RootDrawer } from "./RootDrawer";

import { RootHead } from "../ai-mascot/RootHead";
export function AiButton({ look = "root" }: { look?: "button" | "root" | "sit" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      {look !== "button" ? (
        <StrollingRoot sit={look === "sit"} onOpen={() => setOpen(true)} />
      ) : (
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="ady-bot-host flex min-h-control items-center gap-2 rounded-xs ady-bg-brand ps-1.5 pe-3.5 text-sm font-medium text-on-primary"
        >
          <span className="flex size-6 items-center justify-center rounded-full bg-surface">
            <RootHead size={20} />
          </span>
          {t("today.home.doWithAi")}
          <Icon name="chevronDown" size={16} />
        </button>
      )}
      <RootDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
